import Stack from '@mui/material/Stack';
import Wrapper from 'components/cardano/Wrapper';
import { fetchData } from 'lib/fetchData';
import type { GetServerSideProps, NextPage } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import { API } from '_helpers';
const Banner = dynamic(import('components/cardano/Banner'));
const Section1 = dynamic(import('components/cardano/Section1'));
const Section2 = dynamic(import('components/cardano/Section2'));
const Section3 = dynamic(import('components/cardano/Section3'));
const Section4 = dynamic(import('components/cardano/Section4'));
const Section5 = dynamic(import('components/cardano/Section5'));
const Section6 = dynamic(import('components/cardano/Section6'));
const Section7 = dynamic(import('components/cardano/Section7'));
const Section8 = dynamic(import('components/cardano/Section8'));
const Team = dynamic(import('components/cardano/Team'));
const Partners = dynamic(import('components/cardano/Partners'));
interface IProps {
  header: IHeaders;
  menu: any;
  footer: any;
  company: any;
  seo: any;
  locale: any;
  resolvedUrl: any;
  ourTeam: any;
  partners: any;
  cardano: CCardano;
}

const Cardano: NextPage<IProps> = ({
  menu,
  footer,
  company,
  seo,
  locale,
  resolvedUrl,
  ourTeam,
  partners,
  cardano,
}) => {
  return (
    <Wrapper menu={menu} company={company} footer={footer}>
      <Head>
        <title>{seo.pages[12]?.title}</title>
        <meta name="description" content={seo.pages[12]?.description} />
        <link rel="icon" href={API + company?.favicon?.media?.url} />
        <meta name="robots" content="index,follow" />
        <meta name="twitter:dnt" content="on" />
        <meta
          property="article:published_time"
          content={new Date().toLocaleTimeString()}
        />
        <meta
          name="publish_date"
          property="og:publish_date"
          content={new Date().toLocaleDateString()}
        />
        <meta
          name="author"
          property="article:author"
          content="Luccin Masirika"
        />
        {/* Open Graph */}
        <meta property="og:title" content={seo?.pages[12]?.title} />
        <meta property="og:description" content={seo?.pages[12]?.description} />
        <meta
          property="og:url"
          content={`https://uptodatedevelopers.com${resolvedUrl}`}
        />
        <meta property="og:image" content={API + seo?.pages[12]?.media?.url} />
        <meta property="og:site_name" content={company?.name} />
        <meta property="og:locale" content={locale} />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content={company?.name} />
      </Head>
      <Stack sx={{ bgcolor: '#060d20', overflow: 'hidden' }}>
        <Banner data={cardano?.banner} />
        <Partners data={cardano?.partners} />
        <Section1 data={cardano?.section1} />
        <Section2 data={cardano?.section2} />
        <Section3 data={cardano?.section3} />
        <Section4 data={cardano?.section4} />
        <Section5 data={cardano?.section5} />
        <Section6 data={cardano?.section6} />
        <Section7 data={cardano?.section7} />
        <Section8 data={cardano?.community} />
        <Team data={cardano?.team} />
      </Stack>
    </Wrapper>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  resolvedUrl,
}) => {
  const menu = await fetchData(`/menu/?_locale=${locale}`);
  const company = await fetchData(`/company/?_locale=${locale}`);
  const footer = await fetchData(`/footer/?_locale=${locale}`);
  const seo = await fetchData(`/seo/?_locale=${locale}`);
  const partners = await fetchData(`/our-partners/?_locale=${locale}`);
  const ourTeam = await fetchData(`/our-team/?_locale=${locale}`);

  const cardano = await fetchData(`/cardano?_locale=${locale}`);

  if (!cardano?._id) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      menu,
      company,
      footer,
      seo,
      locale,
      resolvedUrl,
      ourTeam,
      partners,
      cardano,
    },
  };
};

export default Cardano;
